export default __webpack_public_path__ + "static/media/unhrc committee.5f063b3a.png";